import { PASSWORD_REGEX } from './mixins/changePasswordForm';

(function(global) {
  global.PASSWORD_REGEX = PASSWORD_REGEX;
})(window);



// WEBPACK FOOTER //
// ./resources/office/js/password-regex.js